import React, {useState} from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';

import {Route, Switch, useHistory, useRouteMatch} from "react-router-dom";

import RoutingClients from './client/RoutingClients.js';
import Trainer from './trainer/Trainer.js';
import RoutingKairogramm from './client/RoutingKairogramm.js';


/* root element for trainers */

const TrainerRoot = ({
	trainer,
	products,
	productData,
	showInfo,
	updateTrainer,
	createClient,
	removeClient,
	updateClient,
	issueQuestionnaire,
	checkForQuestionnaire,
	createAnalysis,
}) => {
	// routing
	let { path, url } = useRouteMatch();
	const rootUrl = url;

	// remove ending / so we don't get //
	if (url.endsWith('/'))
		url = url.substring(0, url.length - 1);

	const history = useHistory();


	// profile action
	const [action, setAction] = useState();

	// on a trainer: start editing, remove;

	const startEditing = () => {
		console.log(`started editing a trainer`);
		setAction('edit');
	};

	// cancel editing: return to trainer
	const cancelEditing = () => {
		console.log(`canceled editing a trainer`);
		setAction();
	};

	const handleUpdateTrainer = (...args) => {
		updateTrainer(...args);
		setAction();
	};



	// render

	return (
		<Row className = {'trainer-root'}>
			<Col>
				<Switch>
					{/* profile */}
					<Route path = {'/profile'}>
						<Trainer
							trainer = {trainer}
							action = {action}
							startEditing = {startEditing}
							cancelEditing = {cancelEditing}
							update = {trainerUpdate => handleUpdateTrainer(trainer.id, trainerUpdate)}/>
					</Route>

					{/* clients */}
					<Route path = {'/'}>
						<RoutingClients className = {'my-3'}
							products = {products}
							productData = {productData}
							clients = {trainer.clients}
							createAnalysis = {(clientId, date, analysis) =>
								createAnalysis(trainer.id, clientId, date, analysis)}
							issueQuestionnaire = {(client, questionnaireType) =>
								issueQuestionnaire(trainer.id, client, questionnaireType)}
							checkForQuestionnaire = {(client, questionnaireType) =>
								checkForQuestionnaire(trainer.id, client, questionnaireType)}
							create = {newClient => createClient(trainer.id, newClient)}
							update = {(clientId, clientUpdate) => updateClient(trainer.id, clientId, clientUpdate)}
							remove = {removedClient => removeClient(trainer.id, removedClient)}
							showInfo = {showInfo}/>

						{/* kairogram */}
						<Route path = {'/clients/:clientId/kairogramm/:kairogrammId'}
							render = {routeProps => {
								const clientId = routeProps.match.params.clientId;
								const client = trainer.clients.find(c => c.id === clientId);

								return (
									<Modal
										dialogClassName = {'analysis-view'}
										show = {true}
										size = {'lg'}
										onHide = {() => {
											history.push(`/clients/${clientId}`);
										}}>
										<RoutingKairogramm
											client = {client}/>
									</Modal>
								);
							}}/>
					</Route>
				</Switch>
			</Col>
		</Row>
	);
};

export default TrainerRoot;

export const trainerRoutes = [
	{
		path: '/profile',
		crumble: (data, params) => {
			return [
				{
					text: 'Startseite',
					href: '/',
				},
				{
					text: 'Profil',
					href: '/',
				}
			];
		},
	},
	{
		path: '/clients/:clientId',
		crumble: (data, params) => {
			const tId = data[0].id;
			const cId = params.clientId;
			const trainer = data.find(t => t.id === tId);
			if (!trainer)
				return [];
			const client = trainer.clients.find(c => c.id === cId);
			if (!client)
				return [];
			return [
				{
					text: 'Startseite',
					href: '/',
				},
				{
					text: `${client.surname}, ${client.name} ${client.team ? `[${client.team.name}]` : ''}`,
					href: `/${cId}`,
				},
			];
		},
	},
	{
		path: '/clients/:clientId/kairogramm/:kairogrammId',
		crumble: (data, params) => {
			const tId = data[0].id;
			const cId = params.clientId;
			const kId = params.kairogrammId;
			const trainer = data.find(t => t.id === tId);
			if (!trainer)
				return [];
			const client = trainer.clients.find(c => c.id === cId);
			if (!client)
				return [];
			const kairogramm = client.kairogramme.find(k => k.id === kId);
			if (!kairogramm)
				return [];
			return [
				{
					text: 'Startseite',
					href: '/',
				},
				{
					text: `${client.surname}, ${client.name} ${client.team ? `[${client.team.name}]` : ''}`,
					href: `/${cId}`,
				},
				{
					text: `kairogramm`,
					href: `/${kId}`,
				}
			];
		}
	}
];
